module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=426px height=424px viewBox=\"0 0 426 424\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon points=\"240.96939 105.326208 386.726749 251.083567 425.617622 212.192695 213.485588 0.0606601718 212.778481 0.767766953 212.071374 0.0606601718 -0.0606601718 212.192695 38.8302128 251.083567 185.96939 103.94439 185.96939 423.617622 240.96939 423.617622 240.96939 105.326208\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/arrow-top.svg
// module id = 268
// module chunks = 0